/* eslint-disable */
/**
 * GENERATED FILE — DO NOT EDIT.
 * Source: tooling/theme/theme-presets.json (hash e3c02aeffa41)
 * Regenerate with: node tooling/theme/sync-presets.mjs
 */
export const PRESETS_HASH = "e3c02aeffa41";

export const PRESET_DEFAULTS = {
  "iteach": "indigo",
  "ilearn": "classic-blue"
};

// Preset for a tenant (digits stripped: psb3 -> psb) when no theme is configured.
export const TENANT_PRESET_DEFAULTS = {
  "psb": "maroon"
};

export const THEME_PRESETS = [
  {
    "id": "indigo",
    "name": "Indigo",
    "description": "Purple-indigo gradient — the classic iteach look",
    "brand": {
      "primary": "#667eea",
      "accent": "#764ba2"
    }
  },
  {
    "id": "classic-blue",
    "name": "Classic Blue",
    "description": "Navy and royal blue — the classic ilearn look",
    "brand": {
      "primary": "#1A2845",
      "accent": "#3153cd"
    },
    "dark": {
      "primary": "#6e8ce8",
      "accent": "#7c9af0"
    }
  },
  {
    "id": "maroon",
    "name": "Maroon",
    "description": "Deep maroon — PSB Academy heritage theme",
    "brand": {
      "primary": "#B30537",
      "accent": "#7a0325"
    },
    "dark": {
      "primary": "#f0688d",
      "accent": "#d94f75"
    },
    "tokenOverrides": {
      "light": {
        "--font-heading": "'Lato', sans-serif",
        "--font-body": "'Lato', sans-serif",
        "--font-primary": "'Lato', sans-serif",
        "--font-secondary": "'Lato', sans-serif",
        "--status-warning": "#FFA535",
        "--status-success": "#027E46",
        "--status-danger": "#D52A23",
        "--button-secondary": "#B30537",
        "--button-hover": "#c30937",
        "--button-light": "#FFE8EE",
        "--button-primary": "#1A2845",
        "--background-primary": "#FAFAFA",
        "--background-table": "#F3F3F3",
        "--warning-color": "#FFA535",
        "--success-color": "#027E46",
        "--error-color": "#D52A23",
        "--error-bright": "#FB3836",
        "--text-dark": "#242731",
        "--text-gray": "#1F2937",
        "--text-icon": "#343330",
        "--text-base": "#706E6B",
        "--text-secondary": "#606A70",
        "--text-black": "#080707",
        "--text-muted": "#3E3E3C",
        "--border-primary": "#D9D9D9",
        "--border-table": "#E3E5E8",
        "--link-primary": "#1589EE",
        "--link-light": "#e6f2fd",
        "--link-secondary": "#116ACC",
        "--text-link": "#1589EE",
        "--tooltip-background": "#16325C",
        "--shadow-modal": "rgba(62, 62, 60, 0.25)"
      }
    }
  },
  {
    "id": "teal",
    "name": "Teal",
    "description": "Calm teal and turquoise",
    "brand": {
      "primary": "#0d9488",
      "accent": "#14b8a6"
    }
  },
  {
    "id": "ocean",
    "name": "Ocean",
    "description": "Deep ocean blue and cyan",
    "brand": {
      "primary": "#0077B6",
      "accent": "#00B4D8"
    }
  },
  {
    "id": "forest",
    "name": "Forest",
    "description": "Forest green and sage",
    "brand": {
      "primary": "#2d6a4f",
      "accent": "#52b788"
    }
  },
  {
    "id": "slate",
    "name": "Slate",
    "description": "Minimal graphite and gray",
    "brand": {
      "primary": "#374151",
      "accent": "#6b7280"
    },
    "dark": {
      "primary": "#94a3b8",
      "accent": "#b6c2d4"
    }
  }
];

export function getPresetById(id, app, tenant) {
  const base = (tenant || "").replace(/[0-9]+$/, "");
  const fallbackId =
    TENANT_PRESET_DEFAULTS[base] || PRESET_DEFAULTS[app] || PRESET_DEFAULTS.iteach;
  return (
    THEME_PRESETS.find((p) => p.id === id) ||
    THEME_PRESETS.find((p) => p.id === fallbackId) ||
    THEME_PRESETS[0]
  );
}
